import { useEffect } from "react";
import { useFusionAuth } from "@fusionauth/react-sdk";
import { useNavigate } from "react-router-dom";

const FusionAuthCallback = () => {
  const { handleRedirect } = useFusionAuth();
  const navigate = useNavigate();

  useEffect(() => {
    handleRedirect()
      .then(() => {
        // login success
        navigate("/");
      })
      .catch(err => {
        console.error("FusionAuth redirect failed", err);
        navigate("/login");
      });
  }, []); 
  return <div>Signing you in…</div>;
};

export default FusionAuthCallback;
